module.exports = __webpack_public_path__ + "static/media/first_declension_perf_alpha_img.4d8ce9b7.JPG";